import { StyleSheet } from '@rexlabs/styling';
export default StyleSheet({
  container: {
    backgroundColor: 'white',
    zIndex: 1,
    textAlign: 'left'
  },
  week: {},
  horizontal: {
    position: 'absolute',
    left: 9
  },
  vertical: {
    margin: '0 auto'
  },
  verticalScrollable: {
    margin: '0 auto',
    overflowY: 'scroll'
  },
  animating: {
    transition: 'transform 200ms ease-in-out',
    zIndex: 2
  }
});